module.exports = __webpack_public_path__ + "web_static/img/yellowline.9ebcd94f.gif";